

<!-- 门店分类 -->

<template>
  <div id="mclassification">
    <button-router></button-router>

    <router-view v-slot="{ Component }">
      <!-- <keep-alive> -->
        <component :is="Component"></component>
      <!-- </keep-alive> -->
    </router-view>
  </div>
</template>

<style lang="scss" scoped>
#mclassification {
  height: 100%;
}
</style>
